'use client'

import { Loader2 } from 'lucide-react'
import { InfiniteScrollSentinel } from '@/components/ui/infinite-scroll-sentinel'
import { ConversationListItemComponent } from './conversation-list-item'
import type { ConversationListItem } from '@/hooks/agents/messaging/use-conversations'
import { useTranslations } from "next-intl"


interface ConversationListProps {
  conversations: ConversationListItem[]
  activeId: string | null
  isLoading: boolean
  hasMore: boolean
  loadMoreFailed: boolean
  onSelect: (id: string) => void
  onLoadMore: () => void
  timezone: string
}

export function ConversationList({
  conversations,
  activeId,
  isLoading,
  hasMore,
  loadMoreFailed,
  onSelect,
  onLoadMore,
  timezone,
}: ConversationListProps) {
  const tUi = useTranslations("Messaging.AgentsMessagingInboxConversationList")

  if (isLoading && conversations.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (conversations.length === 0) {
    return (
      <div className="flex items-center justify-center h-full text-sm text-muted-foreground p-4">
        <span key={tUi("noConversationsYet")}>{tUi("noConversationsYet")}</span></div>
    )
  }

  return (
    <div className="overflow-y-auto h-full">
      {conversations.map((conv) => (
        <ConversationListItemComponent
          key={conv.id}
          conversation={conv}
          isActive={conv.id === activeId}
          onClick={() => onSelect(conv.id)}
          timezone={timezone}
        />
      ))}
      <InfiniteScrollSentinel
        hasMore={hasMore}
        isLoading={isLoading}
        hasFailed={loadMoreFailed}
        onLoadMore={onLoadMore}
      />
    </div>
  )
}
